// TODO: Migrate fixtures/tracking to TypeScript
import { trackingDataFixture } from 'fixtures/tracking';
import { CountryCode, LanguageCode } from 'typescript/constants/localization';

export const localeInfoFixture = (overrides = null) => {
  const countryCode = overrides?.storeCode || CountryCode.US;
  const languageCode = overrides?.languageCode || LanguageCode.EN;

  return {
    countryCode,
    languageCode,
  };
};

export const checkoutFlowFixture = (overrides = null) => {
  const orderNumber = overrides?.orderNumber || 'US-123456789';

  const defaults = {
    orderNumber,
    locationId: 'locationId',
    applicationId: 'applicationId',
    trackingData: trackingDataFixture(),
  };

  return { ...defaults, ...overrides };
};

export const savedCardsContextFixture = (overrides = null) => {
  const defaults = {
    savedCardsEnabled: true,
    payWithSavedCard: true,
    setPayWithSavedCard: jest.fn(),
    makeDefaultCard: true,
    setMakeDefaultCard: jest.fn(),
    saveCardToWallet: true,
    setSaveCardToWallet: jest.fn(),
    selectedCard: null,
    setSelectedCard: jest.fn(),
  };

  return { ...defaults, ...overrides };
};
